
export enum PoStatusEnum {
    OPEN = 'O',
    INPROGRESS = 'P',
    COMPLETED = 'C'
}